// import Tooltip from '@material-ui/core/Tooltip';
import { List } from './styles';
import SideMenuItem from './SideMenuItem';
import { useSession } from "context/SessionContext";
import { useConfig } from 'hooks';
import { getSubDomain, verAccessType } from 'components/shared/getUrl';

interface SideMenuProps {
  open: boolean
}
export default function SideMenu({ open }: SideMenuProps) {
  const { menus, loading }: any = useConfig();
  const { signOut } = useSession();
  
  const getAccessType = verAccessType(getSubDomain);
  const getRole = menus?.map((menu: any) => menu.roles?.includes('1'));
  const verMenu =  getRole ? getRole.includes(true) : null;

  if(!loading){
    if ((verMenu && !getAccessType) || (!verMenu && getAccessType)) {
      signOut();
      window.location.replace(`/admin/`);
    }
  }
  return (
    <List>
      {!loading && (
        menus?.map((menu: any) => (
          <SideMenuItem key={menu?.id} {...menu} expanded={open} />
        ))
      )}
    </List>
  )
}
